import React, { useEffect, useState } from "react";
import VisitorForm from "./VisitorForm";
import axios from "axios";
import ExhibitorDashboardNavbar from "../exhibitor/exhibitor_dashboard/ExhibitorDashboardNavbar";
import { useNavigate } from "react-router-dom";
import { storage } from "../../utils/auth";

const ExhibitorStaff = () => {
  const [show, setShow] = useState(true);
  const [statusMessage, setStatusMessage] = useState("");
  const navigate = useNavigate();
  const exhibitorAgentType = localStorage.getItem("exhibitor_agent_type");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = storage.get("token");
        const settingsRes = await axios.get(
          `${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`,
          {
            headers: {
              token: token,
            },
          }
        );
        
        if (settingsRes.data && settingsRes.data.data) {
          const settings = settingsRes.data.data;
          if (settings.exhibitor_staff !== "active") {
            setShow(false);
            setStatusMessage("Form is suspended");
            return;
          }

          const statusRes = await axios.get(
            `${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`,
            {
              headers: {
                token: token,
              },
            }
          );

          const hasStaffStatus = statusRes.data.staffstatus;
          const extraStaffAllowed = settings.extra_staff_registration !== "inactive";

          if (!hasStaffStatus && !extraStaffAllowed) {
            setShow(false);
            setStatusMessage("The limit to add new members has exhausted");
            return;
          }
        }
        setShow(true);
      } catch (err) {
        if (err.response && err.response.status === 401) {
          navigate("/superadmin/login");
          storage.clearNamespace();
          localStorage.removeItem("user_id");
          localStorage.removeItem("type_of_user");
        }
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <ExhibitorDashboardNavbar />
      {show ? (
        <VisitorForm
          formHeader={"Exhibitor staff registration"}
          formName={"exhibitor_staff"}
          barcodeId={""}
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="alert alert-warning text-center" role="alert">
            <strong>{statusMessage || "Form is suspended"}</strong>
          </div>
        </div>
      )}
    </>
  );
};

export default ExhibitorStaff;
